import {styled} from 'styled-components';
import {Redirect, Route} from 'wouter';

import {Modal} from '@repo/shared-web/components/core/modal';
import {useComponentClass} from '@repo/shared-web/lib/react';

import {AdminPage} from '@repo/website-frontend/components/admin_page';
import {BrowseMoviePage} from '@repo/website-frontend/components/browse_movie_page';
import {BrowseMoviesPage} from '@repo/website-frontend/components/browse_movies_page';
import {KohLantaPage} from '@repo/website-frontend/components/koh_lanta_page';
import {NavBar} from '@repo/website-frontend/components/nav_bar';
import {NzbHealthDebugPage} from '@repo/website-frontend/components/nzb_health_debug_page';
import {NzbsuPage} from '@repo/website-frontend/components/nzbsu_page';

export const App: React.FC = () => {
  const RedirectToNzbsu = useComponentClass(<Redirect to="/nzbsu" />);

  return (
    <Route path="/" nest>
      <>
        <Wrapper>
          <NavBar />
          <Route path="/" component={RedirectToNzbsu} />
          <Route path="/nzbsu" component={NzbsuPage} />
          <Route path="/admin" component={AdminPage} />
          <Route path="/koh-lanta" component={KohLantaPage} />
          <Route path="/debug/nzb-health" component={NzbHealthDebugPage} />
          <Route path="/browse" component={BrowseMoviesPage} />
          <Route path="/browse/:imdbId" component={BrowseMoviePage} />
        </Wrapper>
        <Modal />
      </>
    </Route>
  );
};
App.displayName = 'App';

const Wrapper = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: #151921;
  display: flex;
  flex-direction: column;
  color: white;
  font-size: 16px;
  overflow-y: auto;
`;
